module.exports = __webpack_public_path__ + "img/elementary-school-course-description-3.9c815603.svg";